import VirtualizedList from "./VirtualizedList.vue";
import { pluginify } from "./../../util";
export default pluginify(VirtualizedList);
export { VirtualizedList };
